export const PROJECT_TYPES = [
    "Client",
    "Proposal",
    "Administrative",
    "Internal",
];
/**
 * Client-facing types must carry a client, chosen from SEEDED Deltek data.
 * Never free text.
 */
const CLIENT_FACING = new Set([
    "Client",
    "Proposal",
]);
export function requiresClient(projectType) {
    return CLIENT_FACING.has(projectType);
}
//# sourceMappingURL=project.js.map